import React from 'react';
import styled from 'styled-components';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Button, Icon, Input, InputFormik } from 'components';
import { ColDiv, RowDiv, Text } from 'styles';
import { Formik } from 'formik';
import * as yup from 'yup';

export default function QnaPasswordInput({ password, setPassword, obSubmit }) {
  const { langList } = useOutletContext();
  const navigate = useNavigate();

  const handerChangePass = (password) => {
    setPassword(password);
  };

  const schema = yup.object().shape({
    password: yup.string().required(langList.qnaForm.errorMessages.required)
  });

  return (
    <Container>
      <Formik initialValues={{ password: '' }} validationSchema={schema} onSubmit={obSubmit}>
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <ColDiv $gap={16}>
              <ColDiv $gap={16} $alignItems="center">
                <Icon name="lock" $width={24} $height={24} $padding="0" />
                <Text $whiteSpace="pre" $textAlign="center" $mType="b7">
                  {langList.qnaPwd.text}
                </Text>
              </ColDiv>
              <ColDiv $gap={8}>
                <InputFormik
                  type="password"
                  placeholder={langList.qnaPwd.placeholder}
                  onChange={handerChangePass(formik.values.password)}
                  {...formik.getFieldProps('password')}
                />
                {formik.touched.password && formik.errors.password ? <div className="error">{formik.errors.password}</div> : null}
              </ColDiv>
              <RowDiv $gap={16}>
                <Button label={langList.qnaPwd.cancel} btnType="xLarge" btnStyle="cancel" onClick={() => navigate(-1)} />
                <Button label={langList.qnaPwd.submit} btnType="xLarge" btnStyle="fill" type="submit" />
              </RowDiv>
            </ColDiv>
          </form>
        )}
      </Formik>
    </Container>
  );
}

const Container = styled(ColDiv)`
  padding: 48px 104px;
  align-items: center;
  margin: auto;
  border: 1px solid ${({ theme }) => theme.colors.lighter};
  border-radius: 6px;
  gap: 48px;

  @media ${({ theme }) => theme.device.tablet} {
    margin: 72px auto 0;
    padding: 48px 72px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    margin: 48px auto 0;
    padding: 24px;
    gap: 24px;
  }
`;
